<div class="document-add" fxLayout="column" fxLayoutGap="15px" >

  <div fxLayout="row" >


    <div  class="h2" fxFlex="30">
      <h2>Lista kolumn</h2>
    </div>
    <div  class="button-exit"  fxFlex="70" fxLayout="row" fxLayoutAlign="end center">
      <button mat-button  class="report-button"></button>
      <button mat-button class="clear-button"(click)="clearSelection()" ><mat-icon>delete</mat-icon><span> Wyczyść zaznaczenie</span></button>
      <button  mat-button class="report-button" (click)="downloadReport()"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
      <button mat-button class="save-button"(click)="save()" ><mat-icon>save</mat-icon><span> Zapisz</span></button>
      <button  mat-button class="cancel-button"(click)="closeDialog($event)"><mat-icon>cancel</mat-icon><span> Anuluj</span></button>

<!--      <button (click)="downloadReport()" mat-icon-button color="accent" matTooltip="Pobierz raport"><mat-icon>download</mat-icon> </button>-->
<!--      <button (click)="save()" mat-icon-button color="primary" matTooltip="Zapisz"><mat-icon>save</mat-icon> </button>-->
<!--      <button (click)="closeDialog($event)" mat-icon-button color="warn" matTooltip="Wyjście"><mat-icon>cancel</mat-icon></button>-->
    </div>
  </div>


  <form>

    <table fxFlex="100"  class="table" >
      <tr *ngFor="let headers of activeHeaders">
        <td *ngFor="let header of headers" >
          <mat-checkbox
            (change)="add(header)"
            [checked]="isSelect(header)"
          >
            {{header}}
          </mat-checkbox>
        </td>
      </tr>
      <tr *ngFor="let headers of blockHeaders">
        <td *ngFor="let header of headers" >
          <mat-checkbox
            [disabled]="true"
            (change)="add(header)"
            [checked]="isSelect(header)"
          >
            {{header}}
          </mat-checkbox>
        </td>
      </tr>
    </table>
  </form>


<!--  <div fxLayout="row" fxLayoutGap="15px">-->
<!--    <button (click)="downloadReport()"-->
<!--            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>-->
<!--    <button (click)="save()"-->
<!--            mat-raised-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>-->
<!--    <button (click)="closeDialog($event)" mat-raised-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>-->
<!--  </div>-->


</div>
